import { Slugs } from '@/constants/slugs';
import { SettingGroup, SettingGroupResponse } from '@/types/setting-groups';

export const getSettingsGroupValues = (
  data: SettingGroupResponse | null,
  keys: Slugs[]
) => {
  return keys.reduce((acc, next) => {
    if (!data) {
      acc[next] = null;
      return acc;
    }
    const value = data.settings.find((el) => el.slug === next) ?? null;
    acc[next] = value;
    return acc;
  }, {} as Record<(typeof keys)[number], SettingGroup | null>);
};
